export const MIN_DATE = new Date('1973-01-01')
export const MAX_DATE = new Date('2070-01-01')
export const MOBILE_WIDTH = '770px'
export const PICKER_MASKS = {
  input: 'DD/MM/YYYY',
  weekdays: 'WWW',
}
